import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useEffect, useState } from 'react';

export const NewTimeRange = ({ handleChange, startTime, endTime, handleError, setOpen }) => {
  const [error, setError] = useState('');

  useEffect(() => {
    const validStart = new Date(
      null,
      null,
      null,
      startTime?.split(':')[0],
      startTime?.split(':')[1]
    );
    const validEnd = new Date(null, null, null, endTime?.split(':')[0], endTime?.split(':')[1]);

    if (validEnd && validStart && validStart > validEnd) {
      setError('End time must be after start time');
      handleError(true);
    } else {
      setError('');
      handleError(false);
    }
  }, [startTime, endTime]);

  return (
    <Box
      sx={{
        boxShadow: 1,
        zIndex: 1000,
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        top: '35px',
        left: '7px',
        backgroundColor: 'white',
        px: 1,
        pb: 1,
        borderRadius: '5px'
      }}
    >
      <TimePicker
        style={{ width: 100, marginRight: '4px' }}
        showSecond={false}
        defaultValue={
          startTime
            ? moment(new Date(null, null, null, startTime?.split(':')[0], startTime?.split(':')[1]))
            : moment().startOf('day')
        }
        onChange={(e) => handleChange(e, 'time_after')}
        minuteStep={15}
      />
      <p>to</p>
      <TimePicker
        style={{ width: 100, marginLeft: '4px' }}
        showSecond={false}
        defaultValue={
          endTime
            ? moment(new Date(null, null, null, endTime?.split(':')[0], endTime?.split(':')[1]))
            : moment().startOf('day')
        }
        onChange={(e) => handleChange(e, 'time_before')}
        minuteStep={15}
      />
      {error ? (
        <Box
          sx={{
            position: 'absolute',
            top: '65%',
            left: '50%',
            transform: 'translateX(-50%)',
            minWidth: '210px'
          }}
        >
          <Typography fontFamily={'Mulish'} fontSize={13} color={'red'} textAlign={'center'}>
            {error}
          </Typography>
        </Box>
      ) : null}

      <Typography
        onClick={() => setOpen(false)}
        fontFamily={'Mulish'}
        fontSize={13}
        ml={0.4}
        px={1}
        color={'red'}
        textAlign={'center'}
        sx={{
          cursor: 'pointer',
          opacity: 0.7,
          ':hover': {
            opacity: 1
          }
        }}
      >
        Close
      </Typography>
    </Box>
  );
};

NewTimeRange.propTypes = {
  handleChange: PropTypes.func.isRequired,
  startTime: PropTypes.object.isRequired,
  endTime: PropTypes.object.isRequired,
  handleError: PropTypes.func.isRequired,
  setOpen: PropTypes.func.isRequired
};

export default NewTimeRange;
